import layer3 from "../../assets/Charts/layer3.png";
import tarazImg from "../../assets/Charts/taraz.png"
import levelImg from "../../assets/Charts/level.png";
import totalInputLakeImg from "../../assets/Charts/total-input-lake.png";
import rainfalImg from "../../assets/Charts/rainfal.png";
// import sunClockImg from "../../assets/Charts/sun-clock.png";
import tabkhirImg from "../../assets/Charts/tabkhir.png"
import tempretureWeatherImg from "../../assets/Charts/tempreture-weather.png"
import relativeHumidityImg from "../../assets/Charts/relative-humidity.png"
import directionWindImg from "../../assets/Charts/direction-wind.png"
import speedWindImg from "../../assets/Charts/speed-wind.png"

// const Dam = {
//   inputs: [
//     {
//       id: 'dam_id',
//       elementConfig: {
//         type: 'text',
//         placeholder: 'کد سد',
//       },
//       value: '',
//       validation: {
//         required: true,
//         isNumeric: true,
//       },
//       valid: false,
//       touched: false,
//       queryParams: true,
//     },
//   ],
//   url: 'download/dam_detail/',
//   title: 'سد',
// };

const Hydrometric = {
  id: 'station_id',
  singleOption: [
    {
      value: 'دبی',
      gainValue: 'discharge',
      // gainValue: 'rainfall',
      unit: (
        <span>
          m<sup>3</sup>/s
        </span>
      ),
      color: '19, 156, 216',
      img:layer3
    },
  ],
  url: 'hydrometric-discharge',
  download: 'hydrometric_detail',
  downloadId: 'hydrometric_id',
  title: 'ایستگاه هیدرومتریک',
};

const Synoptic = {
  id: 'station_id',
  options: [
    { value: 'سرعت باد', gainValue: 'wind_speed_knots', unit: 'knots', color: '159, 157, 36',img:speedWindImg },
    { value: 'جهت باد', gainValue: 'wind_direction_degree', unit: 'degrees from true north', color: '145, 155, 206',img:directionWindImg },
    { value: 'رطوبت نسبی', gainValue: 'relative_humidity', unit: '%', color: '0, 149, 169',img:relativeHumidityImg },
    // { value: 'معتبر', gainValue: '', unit: '', color: '' },
    { value: 'تبخیر', gainValue: 'evp', unit: 'mm', color: '88, 166, 204',img:tabkhirImg },
    { value: 'بارش', gainValue: 'rainfall', unit: 'mm', color: '231, 201, 67',img:rainfalImg },
    { value: 'دمای بیشینه', gainValue: 'maximum_temp', unit: 'f@2m', color: '231, 201, 67',img:tempretureWeatherImg },
    { value: 'دمای هوا', gainValue: 'medium_temp', unit: 'f@2m', color: '77, 183, 173',img:tempretureWeatherImg },
    { value: 'دمای کمینه', gainValue: 'minimum_temp', unit: 'f@2m', color: '231, 201, 67',img:tempretureWeatherImg },

    // { value: 'بارش', gainValue: 'rainfall' },
    // { value: 'رطوبت نسبی', gainValue: 'relative_humidity' },
    // { value: 'سرعت باد', gainValue: 'wind_direction_degree' },
    // { value: 'کمترین دما', gainValue: 'minimum_temp', unit: 'mm', color: '88, 166, 204',img:tabkhirImg},
    // { value: 'بیشترین دما', gainValue: 'maximum_temp' },
    // { value: 'wind_speed_knots', gainValue: 'wind_speed_knots' },
    // { value: 'دما متوسط', gainValue: 'medium_temp' },
  ],
  url: 'synoptic',
  download: 'synoptic_detail',
  downloadId: 'synoptic_id',
  title: 'سینوپتیک',
};

const Aquifer = {
  id: 'aquifer_id',
  singleOption: [{ value: 'بارش', gainValue: 'rainfall', unit: 'mm',img:rainfalImg }],
  url: 'aquifer-volume',
  title: 'حوضه آبریز',
};

// const Weather = {
//   inputs: [
//     {
//       id: 'weather_station_id',
//       elementConfig: {
//         type: 'text',
//         placeholder: 'کد ایستگاه',
//       },
//       value: '',
//       validation: {
//         required: true,
//         isNumeric: true,
//       },
//       valid: false,
//       touched: false,
//       queryParams: true,
//     },
//     {
//       id: 'weather_item',
//       elementConfig: {
//         type: 'select',
//         placeholder: 'نوع ایستگاه',
//         options: [
//           { value: 'بارش', gainValue: 'rainfall' },
//           { value: 'تبخیر', gainValue: 'evaporation' },
//         ],
//       },
//       indexValue: -1,
//       value: '',
//       queryParams: true,
//     },
//   ],
//   url: 'get_chart_data/weather/',
//   title: 'ایستگاه هواشناسی',
// };

// const Snow = {
//   inputs: [
//     {
//       id: 'weather_station_id',
//       elementConfig: {
//         type: 'text',
//         placeholder: 'کد ایستگاه',
//       },
//       value: '',
//       validation: {
//         required: true,
//         isNumeric: true,
//       },
//       valid: false,
//       touched: false,
//       queryParams: true,
//     },
//     {
//       id: 'field',
//       elementConfig: {
//         type: 'select',
//         placeholder: 'نوع دیتا',
//         options: [
//           { value: 'attitude_water_snow', gainValue: 'attitude_water_snow' },
//           { value: 'چگالی', gainValue: 'density' },
//           { value: 'عمق برف', gainValue: 'deep_snow' },
//         ],
//       },
//       indexValue: -1,
//       value: '',
//       queryParams: true,
//     },
//   ],
//   url: 'get_chart_data/snow/',
//   title: 'برف',
// };

// const Temp = {
//   inputs: [
//     {
//       id: 'weather_station_id',
//       elementConfig: {
//         type: 'text',
//         placeholder: 'کد ایستگاه',
//       },
//       value: '',
//       validation: {
//         required: true,
//         isNumeric: true,
//       },
//       valid: false,
//       touched: false,
//       queryParams: true,
//     },
//     {
//       id: 'field',
//       elementConfig: {
//         type: 'select',
//         placeholder: 'نوع دیتا',
//         options: [
//           { value: 'کمترین دما', gainValue: 'minimum_temp' },
//           { value: 'بیشترین دما', gainValue: 'maximum_temp' },
//           { value: 'دما متوسط', gainValue: 'medium_temp' },
//         ],
//       },
//       indexValue: -1,
//       value: '',
//       queryParams: true,
//     },
//   ],
//   url: 'get_chart_data/temp/',
//   title: 'دما',
// };

const Lake = {
  options: [
    {
      value: 'مجموع ورودی',
      gainValue: 'total_input',
      unit: (
        <span>
          m<sup>3</sup>/s
        </span>
      ),
      color: '159, 168, 218',
      img:totalInputLakeImg
    },
    { value: 'سطح', gainValue: 'area', unit: 'm', color: '30, 136, 229',img:levelImg },
    {
      value: 'تراز',
      gainValue: 'level',
      unit: (
        <span>
          m<sup>3</sup>/s
        </span>
      ),
      color: '66, 165, 245',
      img:tarazImg
    },
    { value: 'حجم', gainValue: 'volume', unit: 'BCM', color: '144, 202, 249',img:layer3 },
  ],
  url: 'lake',
  download: 'lake_level_detail',
  downloadId: 'lake_id',
  title: 'دریاچه',
};

// const WareHouse = {
//   id: 'lake_id',
//   selectId: 'field',
//   options: [
//     { value: 'مجموع کشاورزی', gainValue: 'farm', unit: 'mm', color: '174, 213, 129' },
//     { value: 'مجموع شرب', gainValue: 'drink', unit: 'mm', color: '144, 202, 249' },
//     { value: 'مجموع صنعت', gainValue: 'dust', unit: 'mm', color: '188, 170, 164' },
//     { value: 'مجموع دریاچه', gainValue: 'lake', unit: 'mm', color: '21, 101, 192' },
//     { value: 'مجموع حجم', gainValue: 'volum', unit: 'mm', color: '207, 216, 220' },
//   ],
//   url: 'aquifer',
//   title: 'مخزن',
// };

export const ChartTypes = {
  Hydrometric: Hydrometric,
  Synoptic: Synoptic,
  Aquifer: Aquifer,
  Lake: Lake,
  // WareHouse: WareHouse,
  // Weather: Weather,
  // Snow: Snow,
  // Temp: Temp,
};

// export const ChartTypesTitles = ['Hydrometric', 'Synoptic', 'Aquifer', 'Weather', 'Snow', 'Temp', 'Lake', 'WareHouse'];
export const ChartTypesTitles = ['Synoptic', 'Hydrometric', 'Aquifer', 'Lake'];
